import { ActionBarItem } from '@workwave-tidal/core/components/ActionBar'
import { Close } from '@workwave-tidal/core/icons'
import { ModalHeader } from '@/components/Modal'

import { useTexts } from '../useTexts'
import { useController } from '../hooks/useController'

export function Header() {
  const texts = useTexts()
  const { close } = useController()

  return (
    <ModalHeader
      title={texts.modalTitle}
      subtitle={texts.modalSubTitle}
      actions={[
        <ActionBarItem
          icon={<Close />}
          key="close"
          onClick={close}
          label=""
          testId="close-button"
        />,
      ]}
    />
  )
}
